if (!window.Eurus.loadedScript.includes('cart-countdown-timer.js')) {
  window.Eurus.loadedScript.push('cart-countdown-timer.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xCartCountdownTimer', (messageTemplate, minutes, expireAction) => ({
        timeLeft: null,
        timestamp: null,
        interval: null,
        formattedMessage: '',
        message: messageTemplate,
        countdownTime: minutes * 60,
        action: expireAction,
        loadingClearCart: false,
        errorMessage: false,
        clearSuccess: false,

        // Initialize timer
        initCountdown() {
          const savedState = this.loadState();
          if (this.timeLeft === null || (savedState && savedState.timeLeft === 0)) {
            this.sync(this.countdownTime);
          }
          this.handleCountdown();
          this.clearInterval();
          this.startCountdown();
        },

        // Synchronize remaining time
        sync(countdownTime) {
          const savedState = this.loadState();
          if (savedState && savedState.timeLeft > 0) {
            const elapsed = Math.floor((Date.now() - savedState.timestamp) / 1000);
            this.timeLeft = Math.max(0, savedState.timeLeft - elapsed);
          } else {
            this.timeLeft = countdownTime;
          }
          this.timestamp = Date.now();
          this.saveState();
        },

        // Reset timer manually or on repeat
        reset(countdownTime) {
          this.timeLeft = countdownTime;
          this.timestamp = Date.now();
          this.saveState();
        },

        // Clear interval helper
        clearInterval() {
          if (this.interval) {
            clearInterval(this.interval);
            this.interval = null;
          }
        },

        // Remove from localStorage
        clearLocalStorage() {
          localStorage.removeItem('cartCountdown');
        },

        // Save current timer state
        saveState() {
          localStorage.setItem(
            'cartCountdown',
            JSON.stringify({
              timeLeft: this.timeLeft,
              timestamp: this.timestamp,
            })
          );
        },

        // Load saved state
        loadState() {
          const savedState = localStorage.getItem('cartCountdown');
          return savedState ? JSON.parse(savedState) : null;
        },

        // Start countdown interval
        startCountdown() {
          this.interval = setInterval(() => {
            if (this.timeLeft > 0) {
              this.timeLeft--;
              this.handleCountdown();
            } else {
              this.clearInterval();
              this.handleExpireAction();
            }
          }, 1000);
        },

        // Render formatted time string
        handleCountdown() {
          const hours = Math.floor(this.timeLeft / 3600);
          const minutes = Math.floor((this.timeLeft % 3600) / 60);
          const seconds = this.timeLeft % 60;

          let timeString = '';

          if (hours > 0) {
            timeString += `${hours} hour${hours !== 1 ? 's' : ''}`;
          }

          if (minutes > 0) {
            timeString += (hours > 0 ? ', ' : '') + `${minutes} minute${minutes !== 1 ? 's' : ''}`;
          }

          if (seconds >= 0) {
            timeString += (hours > 0 || minutes > 0 ? ', and ' : '') + `${seconds} second${seconds !== 1 ? 's' : ''}`;
          }

          const formattedTime = `<span class="font-bold">${timeString}</span>`;
          this.formattedMessage = this.message.replace('{timer}', formattedTime);
        },

        // Clear cart when time expires
        clearCart() {
          this.loadingClearCart = true;
          this.errorMessage = false;
          fetch(window.Shopify.routes.root + 'cart/clear.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              sections: Alpine.store('xCartHelper')
                .getSectionsToRender()
                .map((section) => section.id),
            }),
          })
            .then((response) => response.json())
            .then((response) => {
              this.clearSuccess = true;
              Alpine.store('xCartHelper').getSectionsToRender().forEach((section) => {
                const sectionElement = document.querySelector(section.selector);
                if (sectionElement && response.sections[section.id]) {
                  sectionElement.innerHTML = getSectionInnerHTML(
                    response.sections[section.id],
                    section.selector
                  );
                }
              });
              Alpine.store('xCartHelper').currentItemCount = parseInt(
                document.querySelector('#cart-icon-bubble span').innerHTML
              );
              document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
            })
            .catch((error) => {
              console.error('Error:', error);
            })
            .finally(() => {
              this.loadingClearCart = false;
            });
        },

        // Handle what happens when timer ends
        handleExpireAction() {
          switch (this.action) {
            case 'repeat_countdown':
              this.reset(this.countdownTime);
              this.clearInterval();
              this.startCountdown();
              break;

            case 'hide_message':
              const el = document.getElementById('x-cart-countdown-timer');
              if (el) {
                el.style.display = 'none';
                this.clearLocalStorage();
              }
              break;

            case 'clear_cart':
              this.clearCart();
              break;

            default:
              console.error('Unknown action:', this.action);
          }
        },
      }));
    });
  });
}
